export default {
  LinkSidebar: state => state.LinkSidebar,
  EnbModal: state => state.EnbModal,
  UploadImg: state => state.UploadImg,
  SelectedProdEdit: state => state.SelectedProdEdit[0],
  SelectedCategEdit: state => state.SelectedCategEdit,
  Categorias: state => state.Categorias,
  SelectedProds: state => state.SelectedProdEdit,
  StatusProd: state => state.StatusProd,
  SelectedGiftEdit: state => state.SelectedGiftEdit,
  Gifts: state => state.Gifts,
  Template03: state => state.Template03,
  IconSelected: state => state.IconSelected,
  Produtos: state => state.Produtos,
  GiftValidate: state => state.GiftValidate,
  FilterProdPainel: state => state.FilterProdPainel,
  Frete: state => state.Frete,
  FreteTabelaBairro: state => state.FreteTabelaBairro,
  ProdutoStatus: state => state.ProdutoStatus
}
